import React, { useEffect } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { HelpController } from '../../core/help/HelpController';
import { HelpTip } from '../../core/help/HelpTip';
import { Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { ParticipantManager } from '../participants/ParticipantManager';
import { switchToMeetingMode } from './MeetingModeCommands';

const startMeetingHaugTip = HelpTip(
    'startMeeting',
    'meetingHeader',
    'People are starting to join...',
    'When your team arrives, click the Start Meeting button to begin your session.  This will make you the "Host" and enable special collaboration functions, e.g. Private Writing.',
);

export const MeetingStartHeaderButton = () => {

    const dispatch = useResolve(CommandDispatcher);
    const onClick = () => dispatch(switchToMeetingMode);

    const haug = useResolve(HelpController);
    const ptpts = useResolve(ParticipantManager);

    useEffect(() =>
        ptpts.on('join', () => {
            if (ptpts.online().length >= 3) {
                haug.openTip(startMeetingHaugTip);
            }
        })
    );

    return <Flexer>
        <DropButton id="start-meeting" data-action="editor.openMeetingMenu" rounding="full" padding=".5 1.5" onClick={onClick}>
            <Title flush size="lg" weight="400">
                Start Meeting
            </Title>
        </DropButton>
    </Flexer>;
};
